"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.systemActivity = void 0;
exports.systemActivity = [
    {
        action: "ASSIGN_PROFILE",
        timestamp: "2023-11-09 21:43:57 UTC",
        tenantId: "5a47d569-c0fe-4293-8bdc-56b21f6094bc",
        serviceLine: "null",
        targetEntityUuid: "6b49ae3d-6c53-4ddb-abab-30615768b2fd",
        targetEntityType: "WORKITEM",
        metadata: {
            profileId: "e36597ab-f973-45a8-adb0-7b0cd7c68de9",
            profileName: "My Test Profile"
        },
        activityType: "SYSTEM"
    }
];
//# sourceMappingURL=system-activity.js.map